export function sleep(ms = 3000) {
  return new Promise((resolve) => setTimeout(resolve, Math.random() * ms));
}
